import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "orders-item-desktop__close" }

import { OtMarketId } from '@1trading/design-system';
import { computed, type PropType } from 'vue';

import { MarketType } from '@exchange/libs/market/service/src/lib/market-model';
import { OrderAmount, OrderPrice, OrderSide, OrderTime, OrderStatus as OrderStatusToDisplay, OrderTotal, OrderType } from '@exchange/libs/order/shared-components/src';
import { MyOrdersListType } from '@exchange/libs/order/shared-model/src/lib/order-essentials';
import type { OrderWithTradesModel } from '@exchange/libs/order/shared-model/src/lib/order-model';

import DivTableCell from './DivTableCell.vue';
import DivTableRow from './DivTableRow.vue';
import OrderCloseButton from './OrderCloseButton.vue';
import useOrder from '../useOrder';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersItemDesktop',
  props: {
  cancelOrder: { type: Function as PropType<(id: string) => Promise<void>>, required: true },
  isCurrentMarketOrder: { type: Boolean, required: true },
  order: { type: Object as PropType<OrderWithTradesModel>, required: true },
  showOrderType: { type: Boolean, required: true },
  type: { type: String as PropType<MyOrdersListType>, required: true },
},
  setup(__props) {

const props = __props;

const { animation, market, marketIsInMaintenance, marketIsSuspended, myOrdersSettings, showTimestamp } = useOrder(props.order, props.type);

const isOpen = computed(() => props.type === MyOrdersListType.open);
const orderItemClasses = computed(() => ({
  // For Filled and Open orders
  'animation-running': myOrdersSettings.value.allowAnimations ? animation.value : '',
  'orders-item-desktop--animated': myOrdersSettings.value.allowAnimations,
  [props.order.isBuy ? 'buy' : 'sell']: true,
  [props.type === 'open' ? 'orders-item-desktop--open' : 'orders-item-desktop--filled']: true,
  'status-filled-closed': props.order.status === 'FILLED_CLOSED',
  'status-filled-fully': props.order.status === 'FILLED_FULLY',
  'status-filled-rejected': props.order.status === 'FILLED_REJECTED',

  // Open orders only
  'market-suspended': marketIsSuspended.value,
  'market-in-maintenance': marketIsInMaintenance.value,
  'status-open': props.order.status === 'OPEN',
  'status-triggered': props.order.status === 'STOP_TRIGGERED',
  'status-filled': props.order.status === 'FILLED',
  'status-closing': props.order.status === 'CLOSING',
  'status-closed': props.order.status === 'CLOSED',
  'status-rejected': props.order.status === 'REJECTED',
  'status-failed': props.order.status === 'FAILED',
}));

return (_ctx: any,_cache: any) => {
  const _component_ot_lozenge = _resolveComponent("ot-lozenge")!

  return (_openBlock(), _createBlock(DivTableRow, {
    class: _normalizeClass(["orders-item-desktop", orderItemClasses.value]),
    style: _normalizeStyle({ 'animation-name': _unref(animation) }),
    "data-id": __props.order.id
  }, {
    default: _withCtx(() => [
      _createVNode(DivTableCell, { class: "orders-item-desktop__cell time" }, {
        default: _withCtx(() => [
          _createVNode(_unref(OrderTime), {
            order: __props.order,
            "force-absolute-time": _unref(showTimestamp),
            "list-type": __props.type
          }, null, 8, ["order", "force-absolute-time", "list-type"])
        ]),
        _: 1
      }),
      _createVNode(DivTableCell, { class: "orders-item-desktop__cell market-id" }, {
        default: _withCtx(() => [
          _createVNode(_unref(OtMarketId), {
            "market-id": __props.order.marketName,
            "is-link": false,
            "instrument-code": __props.order.instrumentCode
          }, null, 8, ["market-id", "instrument-code"]),
          (_unref(market)?.type === _unref(MarketType).PERP)
            ? (_openBlock(), _createBlock(_component_ot_lozenge, {
                key: 0,
                filled: false,
                text: _ctx.$t('fundamentals.perpetual.short'),
                class: "orders-item-desktop__lozenge"
              }, null, 8, ["text"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(DivTableCell, { class: "orders-item-desktop__cell compact-cell" }, {
        default: _withCtx(() => [
          _createVNode(_unref(OrderSide), {
            "is-buy": __props.order.isBuy
          }, null, 8, ["is-buy"])
        ]),
        _: 1
      }),
      (__props.showOrderType)
        ? (_openBlock(), _createBlock(DivTableCell, {
            key: 0,
            class: "orders-item-desktop__cell type"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(OrderType), {
                order: __props.order,
                market: _unref(market)
              }, null, 8, ["order", "market"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(DivTableCell, { class: "orders-item-desktop__cell has-currency" }, {
        default: _withCtx(() => [
          _createVNode(_unref(OrderAmount), {
            order: __props.order,
            market: _unref(market),
            "list-type": __props.type
          }, null, 8, ["order", "market", "list-type"])
        ]),
        _: 1
      }),
      _createVNode(DivTableCell, { class: "orders-item-desktop__cell has-currency" }, {
        default: _withCtx(() => [
          _createVNode(_unref(OrderPrice), {
            order: __props.order,
            market: _unref(market)
          }, null, 8, ["order", "market"])
        ]),
        _: 1
      }),
      _createVNode(DivTableCell, { class: "orders-item-desktop__cell total has-currency" }, {
        default: _withCtx(() => [
          _createVNode(_unref(OrderTotal), {
            order: __props.order,
            market: _unref(market),
            "list-type": __props.type
          }, null, 8, ["order", "market", "list-type"])
        ]),
        _: 1
      }),
      (isOpen.value)
        ? (_openBlock(), _createBlock(DivTableCell, {
            key: 1,
            class: "orders-item-desktop__cell status"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(OrderStatusToDisplay), {
                order: __props.order,
                market: _unref(market)
              }, null, 8, ["order", "market"]),
              _createElementVNode("div", _hoisted_1, [
                (isOpen.value)
                  ? (_openBlock(), _createBlock(OrderCloseButton, {
                      key: 0,
                      variant: "desktop",
                      order: __props.order,
                      "market-in-maintenance": _unref(marketIsInMaintenance),
                      "cancel-order": __props.cancelOrder
                    }, null, 8, ["order", "market-in-maintenance", "cancel-order"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class", "style", "data-id"]))
}
}

})